import React, { FC, useState } from 'react';
import { BlockSelectField } from '@common/components/FormElements/BlockSelectField';
import { TranslationKey, useTranslations } from '@lang';
import { SearchIcon } from '@root/styles/icons';
import { useRouter } from 'shared-routing';
import { FancySelectBoxTitle, FancySelectBoxWrapper, IconWrapper } from './FancySelectBox.styles';

type FancySelectBoxProps = {
  options: {
    value: string;
    label: string;
  }[];
  title?: TranslationKey;
};

export const FancySelectBox: FC<FancySelectBoxProps> = ({
  options,
  title = 'common.fancySelectBoxTitle',
}) => {
  const { t } = useTranslations();
  const [spaEntityRoute, setSpaEntityRoute] = useState(options?.[0]);
  const router = useRouter();
  const gotoSpaEntityPage = () => {
    router.push({ pathname: spaEntityRoute.value });
  };

  return options.length ? (
    <FancySelectBoxWrapper>
      <BlockSelectField
        options={options}
        onChange={(option) => setSpaEntityRoute(option)}
        specialLabel={<FancySelectBoxTitle>{t(title)}</FancySelectBoxTitle>}
        value={spaEntityRoute}
        useNativeDropdownOnMobile={false}
      />
      <IconWrapper onClick={gotoSpaEntityPage} data-testid="searchButton">
        <SearchIcon />
      </IconWrapper>
    </FancySelectBoxWrapper>
  ) : null;
};
